import React from "react";
import { Controller } from "react-hook-form";
import { Link as LinkIcon, ArrowRight } from "lucide-react";
import { Button, Input, Field, Spinner } from "@/components/ui";

interface SmartLinkUrlStepViewProps {
  control: any;
  isFetchingMetadata: boolean;
  onSubmit: () => void;
  destinationUrl: string;
}

export const SmartLinkUrlStepView: React.FC<SmartLinkUrlStepViewProps> = ({
  control,
  isFetchingMetadata,
  onSubmit,
  destinationUrl,
}) => {
  return (
    <div className="flex flex-col gap-6">
      {isFetchingMetadata ? (
        <div className="flex flex-col items-center justify-center py-12 gap-4">
          <div className="relative">
            <Spinner className="size-12" />
            <LinkIcon className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 size-5 text-primary" />
          </div>
          <div className="text-center animate-pulse">
            <h3 className="text-lg font-semibold">Fetching Metadata...</h3>
            <p className="text-sm text-muted-foreground">Preparing your smart link preview</p>
          </div>
        </div>
      ) : (
        <>
          <div className="flex flex-col">
            <div className="text-lg font-semibold text-foreground">What is the destination URL?</div>
            <div className="text-sm text-muted-foreground">Enter the URL where you want to route your traffic.</div>
          </div>
          <Field.Group>
            <Controller
              name="destinationUrl"
              control={control}
              render={({ field, fieldState }) => (
                <Field data-invalid={fieldState.invalid}>
                  <Input
                    {...field}
                    autoFocus
                    placeholder="https://example.com/your-campaign"
                    type="url"
                    className="h-12 text-lg"
                    onKeyDown={e => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        onSubmit();
                      }
                    }}
                  />
                  {fieldState.invalid && <Field.Error errors={[fieldState.error]} />}
                </Field>
              )}
            />
          </Field.Group>
          <Button size="lg" className="w-full h-12" onClick={onSubmit} disabled={!destinationUrl}>
            Continue
            <ArrowRight className="size-5 ml-2" />
          </Button>
        </>
      )}
    </div>
  );
};
